import type { ButtonT } from '@mentimeter/ragnar-ui/button';
import { Button } from '@mentimeter/ragnar-ui/button';

export const SubmitButton = (props: ButtonT) => (
  <Button size="large" variant="primary" type="submit" {...props} />
);
